import { Badge, Input, Card, CardBody } from "reactstrap";

const DisplayQuestions = () => {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center my-6"
      style={{ height: "40vh" }}
    >
      <h2>What is the difference between halal and kosher?</h2>
      <div className="my-2">
        {/* question type */}
        <span>Multiple Choice</span>
        <Badge style={{ backgroundColor: "#E3ECF6", color: "#0B56AE" }}>
          2 marks
        </Badge>
      </div>
      {/* filter by qns type */}
      {/* map options */}
      <div>
        <Card onClick={{}} style={{ width: "200px" }}>
          <CardBody>
            <Input type="checkbox" onChange={() => {}} />
            <span className="mx-2">Option 1</span>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default DisplayQuestions;
